/* Synthetic fixture original — no secrets, no real source. */
export const ready = true;
